<template>
  <v-container fluid class="pa-0">
    <v-progress-linear v-if="data.searching" color="accent darken-4" indeterminate height="2" absolute top></v-progress-linear>
    <div class="ma-0 pa-0" style="position: relative; background-color: #f9f9f9">
      <ViewPlotDetails @onOptionButton="onOptButton" :plotItem="data.activeResultFeature" :objectItems="data.activeResultObjects" :canton="data.activeResultCanton" @onClearClickView="clearClickView" @onObjectItemClicked="onObjectItemClicked" @drawFixPoint="onDrawFixPoint"> </ViewPlotDetails>
      <ViewPlotReport :tab="data.plotReportTabView" :plotItem="data.activeResultFeature" :objectItems="data.activeResultObjects" :canton="data.activeResultCanton" @onClearClickView="clearClickReportView"> </ViewPlotReport>
      <v-navigation-drawer class="search-panel" absolute permanent color="white">
        <div style="" class="pa-2" _v-if="!data.quickSearchDialog">
          <div class="d-flex justify-content-between">
            <v-text-field @focus="qsearchinfo = true" @blur="qsearchinfo = false" _prepend-icon="mdi-magnify" :placeholder="$t('quick-search')" :title="$t('quick-search-for-ch-number-canton-area-street')" v-model="data.searchQuery" dense flat hide-details clearable rounded solo-inverted @keydown.enter="simpleSearch"></v-text-field>
            <v-btn fab text small @click="data.searchDialog = !data.searchDialog" :title="$t('advance-search-tuning')"><v-icon color="primary ">mdi-map-search</v-icon></v-btn>
          </div>
          <div class="grey--text text--darken-1" style="font-size: 13px; line-height: 15px" _v-if="qsearchinfo">
            {{ $t("search-by-parcel-id-number-canton-state-municipality-or-street") }}
          </div>
        </div>

        <div class="ma-0 pa-0">
          <div class="subtitle-2 mt-1 ml-2">
            <span v-if="data.searching">{{ $t("results-are-loading") }}</span>
            <span v-else>{{ $t("found") }} {{ totalSearchResults }} {{ String($t("results")).toLowerCase() }}</span>
          </div>
          <div class="search-pagi mb-3 mx-2 d-flex flex-row justify-center justify-space-around w-100 align-center" v-if="totalSearchResults > data.controlParams.size">
            <v-btn x-small fab @click="changePage(data.controlParams.page - 1)" :disabled="data.controlParams.page === 1" class="mr-1"><v-icon class="v-icon notranslate mdi mdi-chevron-left theme--light"></v-icon></v-btn>
            <span class="subtitle-2 accent--text">{{ $t("page") }} {{ data.controlParams.page }} {{ $t("of") }} {{ MAX_PAGES == 100 ? MAX_PAGES + "+" : MAX_PAGES }}</span>
            <v-btn x-small fab @click="changePage(data.controlParams.page + 1)" :disabled="data.controlParams.page === MAX_PAGES" class="ml-1"><v-icon class="v-icon notranslate mdi mdi-chevron-right theme--light"></v-icon></v-btn>
          </div>

          <div>
            <div class="grey--text mb-3" style="font-size: 12px" aav-if="false">
              <span v-for="filter of convertObjectToHumanFilterList(data.searchObject)" :key="filter.label" class="mr-2">
                {{ filter.label }}:
                <v-chip small class="mb-1">
                  {{ Array.isArray(filter.values) ? filter.values.join(", ") : filter.values }}
                </v-chip>
              </span>
            </div>
            <v-row dense no-gutter class="ma-0 pa-0">
              <v-col class="ma-0 pa-0" v-for="(fullResult, index) in searchResultsPaginated" :key="fullResult.PRC_ID" cols="12" sm="12">
                <PlotItem :plotItem="fullResult" :index="index" :searchClickedPlotID="searchClickedPlotID" @onClick="viewPlotMap" @onFullReport="fullReportPDF"> </PlotItem>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-navigation-drawer>

      <h4 v-if="data.currentZoon < startingZoom" style="border-radius: 5px; padding: 5px; position: absolute; top: 8px; right: 70px; z-index: 1; background-color: rgba(255, 0, 0, 0.4); color: white">
        {{ $t("zoom-in-for-results") }}
      </h4>
      <h4 v-else style="border-radius: 5px; padding: 5px; position: absolute; top: 8px; right: 70px; z-index: 1; background-color: rgba(0, 0, 0, 0.4); color: white">{{ $t("showing") }} {{ data.resultsFound }}</h4>

      <!-- Side Panel for Layer Control -->
      <LayerPanel v-if="loaded" :map="data.map" :isOpen="data.showPanel" @close="onRequestToCloseLayerPanel" :activatePanel="activatePanel" />

      <v-sheet min-height="70vh" rounded="lg">
        <div class="map-wrap w-100" :class="{'with-plot-view': data.activeResultFeature}">
          <div class="map" ref="mapContainer"></div>
        </div>
        <v-btn fab small @click="togglePanel" color="primary" style="position: absolute; top: 10px; right: 10px" :title="$t('toggle-layer-panel')">
          <v-icon>mdi-layers</v-icon>
        </v-btn>
      </v-sheet>
    </div>

    <v-dialog v-model="data.quickSearchDialog" max-width="500" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>{{ $t("search") }}</v-card-title>
        <v-card-text>
          <b> {{ $t("search-by-parcel-id-number-canton-state-municipality-or-street") }}</b>
          <div class="d-flex">
            <v-text-field clearable :placeholder="$t('quick-search')" append-icon="mdi-magnify" :title="$t('quick-search-for-ch-number-canton-area-street')" v-model="data.searchQuery" dense flat hide-details solo-inverted @keydown.enter="simpleSearch"></v-text-field>
            <v-btn text color="primary" @click="simpleSearch">
              {{ $t("search") }}
              <v-icon right>mdi-arrow-right-bold</v-icon>
            </v-btn>
          </div>
          <div class="grey--text text--darken-1" style="font-size: 13px">
            <i> {{ $t("search-instructions") }} </i>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          Access the <a @click="data.searchDialog = true">Advance Search</a> by clicking the <v-icon class="mx-1" color="primary">mdi-map-search</v-icon> icon next to the quick search box (top-left corner), or click below:
          <v-btn class="d-block mt-2" small @click="data.searchDialog = true">
            <v-icon small>mdi-map-search</v-icon> <span class="ms-2">{{ $t("advance-search") }}</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="data.searchDialog" max-width="90%">
      <AdvanceSearch :searchDialog="data.searchDialog" :searchObject="data.searchObject" @onSearch="handleAdvancedSearch" @closeAdvanceSearchDialog="data.searchDialog = false" />

      <v-card v-if="false">
        <v-card-title class="text-h5 grey lighten-4">{{ $t("search-for-parcels") }}</v-card-title>
        <v-card class="mx-auto rounded-lg" flat>
          <v-card-text>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-card>
                <v-card-text>
                  <v-row dense class="mt-0">
                    <v-col cols="3">
                      <v-text-field :label="$t('parcel-no')" v-model="data.searchObject.PRC_NO"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field :label="$t('parcel-id') + ' (' + plotPrefix + '#)'" v-model="data.searchObject.PRC_ID"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field :label="$t('parcel-size-from')" suffix="m²" v-model="data.searchObject.PRC_SUR_from" :rules="[rules.number]"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field :label="$t('parcel-size-to')" suffix="m²" v-model="data.searchObject.PRC_SUR_to" :rules="[rules.number]"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card class="mt-5">
                <v-card-text :class="{'grey lighten-5': !data.searchObject.CANTON}">
                  <v-row dense class="mt-0">
                    <v-col cols="12" class="mb-5">
                      <label>{{ $t("canton") }}</label>
                      <SelectCanton v-model="data.searchObject.CANTON" />
                    </v-col>
                    <v-col cols="6">
                      <label>{{ $t("municipality") }}</label>
                      <SelectLocationName :disabled="!data.searchObject.CANTON" dense v-model="data.searchObject.LOCNAME" :canton="data.searchObject.CANTON" :placeholder="data.searchObject.CANTON ? '' : 'Please select Canton to enable this field'" />
                    </v-col>
                    <v-col cols="6">
                      <label>{{ $t("street") }}</label>
                      <SelectStreet :disabled="!data.searchObject.CANTON" v-model="data.searchObject.STREET" :canton="data.searchObject.CANTON" :locname="data.searchObject.LOCNAME" :placeholder="data.searchObject.CANTON ? '' : 'Please select Canton to enable this field'" />
                    </v-col>

                    <v-col cols="12">
                      <label>{{ $t("thermal") }}</label>
                      <SelectThermal v-model="data.searchObject.GRN_TRM" :canton="data.searchObject.CANTON" :disabled="!data.searchObject.CANTON" :placeholder="data.searchObject.CANTON ? '' : 'Please select Canton to enable this field'" />
                    </v-col>
                    <v-col cols="6">
                      <label>{{ $t("alpha-primary") }}</label>
                      <SelectAlpha v-model="data.searchObject.ALPHA_PRIS" :varname="'ALPHA_PRI'" :canton="data.searchObject.CANTON" :disabled="!data.searchObject.CANTON" :placeholder="data.searchObject.CANTON ? '' : 'Please select Canton to enable this field'" />
                    </v-col>
                    <v-col cols="6">
                      <label>{{ $t("alpha-secondary") }}</label>
                      <SelectAlpha v-model="data.searchObject.ALPHA_SECS" :varname="'ALPHA_SEC'" :canton="data.searchObject.CANTON" :disabled="!data.searchObject.CANTON" :placeholder="data.searchObject.CANTON ? '' : 'Please select Canton to enable this field'" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card class="mt-5">
                <v-card-text>
                  <v-row dense class="mt-5">
                    <v-col cols="6">
                      <label>{{ $t("object-options") }}</label>
                      <v-select
                        dense
                        clearable
                        flat
                        hide-details
                        class="rounded-lg"
                        v-model="data.searchObject.OBJECT_OPTIONS"
                        :items="[
                          {text: $t('all'), value: ''},
                          {text: $t('with-objects'), value: 'With'},
                          {text: $t('without-objects'), value: 'Without'},
                        ]"
                      ></v-select>
                    </v-col>

                    <v-col cols="3" class="mt-3">
                      <v-checkbox dense v-model="data.searchObject.GRN_RAD" :label="$t('radon-content')" flat hide-details class="rounded-lg"></v-checkbox>
                      <v-checkbox dense v-model="data.searchObject.PRO_BUN" :label="$t('protected-building-nat')" flat hide-details class="rounded-lg"></v-checkbox>
                      <v-checkbox dense v-model="data.searchObject.PRC_IND" :label="$t('include-roads')" flat hide-details class="rounded-lg"></v-checkbox>
                    </v-col>
                    <v-col cols="3" class="mt-3">
                      <label>{{ $t("property-type") }}</label>
                      <v-select
                        dense
                        clearable
                        flat
                        hide-details
                        class="rounded-lg"
                        v-model="data.searchObject.PRC_TYP"
                        :items="[
                          {text: $t('Freehold'), value: 'Eigentum'},
                          {text: $t('Leasehold'), value: 'Baurecht'},
                        ]"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" class="d-none">
                      <label>{{ $t("freeway-from") }}</label>
                      <v-text-field dense v-model="data.searchObject.FREEWAY_from" label="" flat hide-details class="rounded-lg"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="d-none">
                      <label>{{ $t("freeway-to") }}</label>
                      <v-text-field dense v-model="data.searchObject.FREEWAY_to" label="" flat hide-details class="rounded-lg"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="advanceSearch" :disabled="data.searching">
              <span v-if="data.searching">{{ $t("loading") }}</span>
              <span v-else>{{ $t("search") }}</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="clearForm">
              {{ $t("clear") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="data.limitReachedDialog" max-width="500" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>{{ $t("stop") }}</v-card-title>
        <v-card-text>
          <div>
            <b>{{ $t("investor-territory") }}</b>
            <p>{{ $t("are-you-searching-for-large-plots") }}</p>
            <p>{{ $t("this-shows-that-you-think-big") }}</p>
            <p>{{ $t("at-terrara-properties-not-public") }}</p>
            <p>{{ $t("allocated-selectively") }}</p>
            <p>{{ $t("each-request-reviewed") }}</p>
            <p>{{ $t("qualified-applicants-contacted") }}</p>
          </div>
          <p class="mt-4">{{ $t("contact-support") }}: <a href="https://terrara.ch/investor.php" target="_blank" rel="noopener noreferrer">https://terrara.ch/investor.php</a></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="data.limitReachedDialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue, Watch} from "vue-property-decorator"
import maplibregl, {Map, Popup, NavigationControl} from "maplibre-gl"
import SelectCanton from "./../component/canton/Select.vue"
import SelectThermal from "./../component/thermals/Select.vue"
import SelectLocationName from "./../component/location-names/Select.vue"
import SelectAlpha from "./../component/alpha/Select.vue"
import SelectStreet from "./../component/street/Select.vue"
import PlotItem from "./PlotItem.vue"
import ViewPlotDetails from "./ViewPlotDetails.vue"
import ViewPlotReport from "./ViewPlotReport.vue"
import {config, utils, rules} from "../../libs/utils"
import {searchService} from "./service"
import {debounce} from "./../../libs/debounce"
import LayerPanel from "./LayerPanel.vue"
import AdvanceSearch from "./AdvanceSearch.vue"

import {cogProtocol, locationValues} from "@geomatico/maplibre-cog-protocol"

@Component({
  components: {LayerPanel, SelectCanton, SelectLocationName, SelectStreet, SelectThermal, SelectAlpha, PlotItem, ViewPlotDetails, ViewPlotReport, AdvanceSearch},
})
export default class Home extends Vue {
  rules = rules
  layers: any = []
  view = "map" //tiles
  searchClickedPlotID = null
  qsearchinfo = false

  apiUrl = config.VUE_APP_SERVER_API
  mapboxStyle = config.VUE_APP_MAPBOX_STYLE
  mapStyleRoot //will be generated in created()
  plotPrefix = config.VUE_APP_PLOT_NUMBER_PREFIX

  onSerachResultFlyTo1stResult = false
  onClickSearchResultFlyToPlot = true
  loaded = false
  searchingTimeoutId
  mapContainer: any
  map: any
  sourceNameSingleView = "singleViewGeo"
  sourceNameClusters = "elasticTileClusters"
  sourceNamePlots = "elasticTilePlots"
  sourceNameObjects = "elasticTileObjects"
  sourceNamePlotsAround = "elasticTilePlotsAround"
  startingCenter: any = config.VUE_APP_MAP_CENTER
  startingZoom = 7
  startingZoomPlotsAround = 14
  startingZoomObjects = 14
  DELAY_IN_POPUP_MS = 388
  selectedObjectInView = null

  hitSearchButton = false
  popup: any
  tabViewDetails = 0
  MAX_PAGES = 1
  data: any = {
    limitReachedDialog: false,
    map: null,
    plotReportTabView: null,
    showPanel: false,
    controlParams: {
      page: 1,
      size: 12,
    },
    searchDialog: false,
    quickSearchDialog: false,
    dialog: false,
    searchQuery: "",
    searchObject: {
      PRC_IND: "Standard",
    },
    newCenter: null,
    resultsFound: 0,
    resultsList: [],
    searching: false,
    activeResultObjects: [],
    activeResultFeature: null,
    activeResultCanton: null,
    currentZoon: 7,
    totalsByLocation: [],
    clickedOnLastFeature: null,
  }
  form: any = {
    valid: false,
  }

  METER_UNIT_CODE = "m" // extract into configuration file per country

  fullResults: any = {}
  searchResultsPaginated: any = []
  totalSearchResults = 0
  objectColors = config.VUE_APP_PLOT_OBJECT_COLORS
  activatePanel: any = null

  constructor() {
    super()
  }

  created() {
    //"https://app.terrara.ch/terrara/style.json" extract from mapboxStyle url by removing last json part. all before is mapStyleRoot
    this.mapStyleRoot = this.mapboxStyle.replace(/\/[^/]+$/, "")
    this.extractQueryParams()

    this.$nextTick(() => {
      setTimeout(() => {
        const mapContainer = this.$refs?.mapContainer as HTMLDivElement
        if (mapContainer) {
          this.mapContainer = mapContainer

          this.popup = new Popup({
            closeButton: false,
            closeOnClick: true,
            closeOnMove: true,
            // subpixelPositioning: true,
            //anchor: 'bottom-right',
            offset: [-5, -5],
            // className: 'custom-map-popup',
          })

          this.loadMap()

          this.search()
        }
      }, 111)
    })
  }
  beforeDestroy() {
    // Logic to handle cleanup before the component is destroyed
    this.data.showPanel = false // or any other logic to reset the LayerPanel
  }

  clearForm() {
    this.data.searchObject = {
      CANTON: null,
      LOCNAME: null,
      STREET: null,
      PRC_NO: null,
      PRC_ID: null,
      PRC_SUR_from: null,
      PRC_SUR_to: null,
      GRN_TRM: null,
      OBJECT_OPTIONS: null,
      PRC_TYP: null,
      GRN_RAD: false,
      PRO_BUN: false,
      PRC_IND: "Standard",
      FREEWAY_from: null,
      FREEWAY_to: null,
      PUTRA_from: null,
      PUTRA_to: null,
      ALPHA_PRI: null,
      ALPHA_SEC: null,
      ALPHA_PRIS: null,
      ALPHA_SECS: null,
    }
    this.form.valid = false
  }

  changePage(newPage) {
    if (newPage > 0 && newPage <= this.MAX_PAGES) {
      this.data.controlParams.page = newPage
      // this.searchMatchingPlots()

      this.searchResultsPaginated = []
      this.searchMatchingPlots()
    }
  }

  onOptButton(btn) {
    console.log("onOptButton", btn)
    // this.data.plotReportTabView = {btn: btn}
    Vue.set(this.data, "plotReportTabView", {btn: btn})
  }

  onObjectItemClicked(obj) {
    this.selectedObjectInView = obj
    this.drawFeatureWithObjectsNEW(this.data.activeResultFeature, [obj], "canvas_obj_" + obj.OBJ_ID)
  }

  togglePanel() {
    this.data.showPanel = !this.data.showPanel
  }
  onRequestToCloseLayerPanel() {
    this.data.showPanel = false
  }

  key2HumanConv(key) {
    return key
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase())
  }

  convertObjectToHumanFilterList(obj) {
    let filterItems: any = []

    for (let key in obj) {
      let lbl = ""
      let val: any = []
      if (obj[key]) {
        if (!obj[key] || obj[key] == "null" || obj[key] == "undefined" || obj[key] == "") {
          continue
        }
        lbl = this.key2HumanConv(key)

        if (key == "PRC_SUR_from") {
          lbl = "Size from"
        } else if (key == "PRC_SUR_to") {
          lbl = "Size to"
        } else if (key == "FREEWAY_from") {
          lbl = "Freeway from"
        } else if (key == "FREEWAY_to") {
          lbl = "Freeway to"
        } else if (key == "PUTRA_from") {
          lbl = "Putra from"
        } else if (key == "PUTRA_to") {
          lbl = "Putra to"
        } else if (key == "LOCNAME") {
          lbl = "Municipality"
        } else if (key == "PRO_BUN") {
          lbl = "Protected"
        } else if (key == "PRC_IND") {
          lbl = "Roads"
        } else if (key == "OBJ_ID_TOTAL") {
          lbl = "Without Objects"
        } else if (key == "PRC_NO") {
          lbl = "Parcel No"
        } else if (key == "PRC_ID") {
          lbl = "Parcel ID"
        } else if (key == "GRN_TRM") {
          lbl = "Thermal"
        }
        if (Array.isArray(obj[key])) {
          obj[key].forEach((item) => {
            if (item.code) {
              val.push(item.code)
            } else {
              val.push(JSON.stringify(item))
            }
          })
        } else {
          if (obj[key].code) {
            if (obj[key].code === true || obj[key].code === "true") {
              val.push("Yes")
            } else {
              val = obj[key].code
            }
            //val.push(obj[key].code)
          } else {
            if (obj[key] === true || obj[key] === "true") {
              val.push("Yes")
            } else if (!Number.isNaN(obj[key])) {
              val = obj[key]
            } else {
              val = obj[key]
            }
          }
        }
        filterItems.push({label: lbl, values: val})
      }
    }
    return filterItems
  }

  clearClickView() {
    Vue.delete(this.data, "plotReportTabView")
    Vue.delete(this.data, "activeResultFeature")
    Vue.delete(this.data, "activeResultObjects")
    Vue.delete(this.data, "activeResultCanton")
  }
  clearClickReportView() {
    Vue.delete(this.data, "plotReportTabView")
    // this.data.plotReportTabView = null
  }

  async viewPlotMap(PRC_ID, position) {
    this.searchClickedPlotID = PRC_ID
    this.clearClickView()

    if (this.onClickSearchResultFlyToPlot) {
      this.flyToSearchResultPosition(position)
    }

    //find object from results based on PRC_ID
    let item = this.searchResultsPaginated.find((i) => {
      return i.PRC_ID == PRC_ID
    })

    this.setupSingleViewPlot(item)

    let featureAndObjects = await this.loadPlotFullForPrcID(PRC_ID)
    this.activatePlotViewNEW(featureAndObjects)
    this.drawFeatureWithObjectsNEW(featureAndObjects?.feature, featureAndObjects?.objects, "canvas")

    //console.log("featureAndObjects?.feature", featureAndObjects?.feature)
    //TODO: this.highlighedSinglePlot(featureAndObjects?.feature)
  }

  loadMap() {
    maplibregl.addProtocol("cog", cogProtocol)
    console.log("Loading map...", this.startingCenter)
    this.data.map = new Map({
      style: this.mapboxStyle,
      center: this.startingCenter,
      zoom: this.startingZoom,
      pitch: 40, // pitch in degrees
      maxPitch: 85, // pitch in degrees
      bearing: 0, // bearing in degrees
      container: this.mapContainer, //[0].value,
      transformRequest: (url, resourceType) => {
        if (url.includes("v1/secure/user/maps/all-around") || url.includes("v1/secure/user/maps/tile")) {
          return {
            url: url,
            headers: {
              Authorization: "Bearer " + searchService.getToken(),
            },
          }
        }
        return {url}
      },
      // antialias: true,
    })
    console.log("Loading map... COMPLETE")

    this.data.map.addControl(
      new NavigationControl({
        showCompass: true,
        showZoom: true,
        visualizePitch: true,
      }),
      "bottom-right",
    )

    this.data.map.on("load", () => {
      this.loaded = true
    })
    this.data.map.on("zoom", () => {
      this.data.currentZoon = this.data.map.getZoom()
    })
    this.data.map.on("zoomend", () => {
      this.data.currentZoon = this.data.map.getZoom()
      this.showLayer()
    })
    this.data.map.on("move", () => {
      this.data.currentZoon = this.data.map.getZoom()
    })
    this.data.map.on("moveend", () => {
      this.data.currentZoon = this.data.map.getZoom()
      this.showLayer()
    })

    this.data.map.on("sourcedata", this.sourceCallback)
    this.data.map.on("data", () => {
      this.additionalData()
    })

    //on idle, set searching to false
    this.data.map.on("idle", () => {
      this.data.searching = false
    })
    this.data.map.on("click", (e) => {
      this.onMapPlotClick(e)
    })
    this.data.map.on("mousemove", (e) => {
      this.onMapMouseMove(e)
    })
    this.data.map.on("mouseleave", (e) => {
      this.onMapMouseLeave(e)
    })
  }

  unmounted() {
    this.data.map.off("load", () => {})
  }

  fullReportPDF(item) {
    console.log("fullReportPDF", item)
    alert("Todo PDF for " + item.PRC_ID)
  }

  @Watch("data.searchObject.CANTON")
  onCantonSet(val) {
    if (val != this.data.searchObject.CANTON) {
      this.data.searchObject.LOCNAME = null
      this.data.searchObject.STREET = null
    }
  }
  @Watch("data.searchObject.LOCNAME")
  onLocName(val) {
    if (val != this.data.searchObject.LOCNAME) {
      this.data.searchObject.STREET = null
    }
  }

  flyCenter() {
    this.data.map.flyTo({
      center: this.startingCenter,
      zoom: this.startingZoom,
      pitch: this.data.map.getPitch(),
      bearing: this.data.map.getBearing(),
      essential: true, // this animation is considered essential with respect to prefers-reduced-motion
    })
  }
  simpleSearch() {
    //REMOVE ADVANCE SEARCH OPTIONS FROM THE SEARCH - PLAIN AND SIMPLE Quick Searcon Only
    this.data.quickSearchDialog = false
    this.data.searchObject = {}
    this.search("simple")
  }
  advanceSearch() {
    this.data.limitReachedDialog = false
    this.data.quickSearchDialog = false
    this.data.searchDialog = false
    this.data.searchQuery = ""
    this.search("advance")
  }

  handleAdvancedSearch(searchObject) {
    this.data.quickSearchDialog = false
    this.data.searchDialog = false
    this.data.searchQuery = ""
    this.data.searchObject = searchObject
    this.search("advance")
  }

  search(typeOfSearch = "simple") {
    debounce.delay(() => {
      this.clearClickView()
      this.flyCenter()
      this.hitSearchButton = true
      this.searchResultsPaginated = []
      this.data.resultsFound = 0
      this.data.controlParams.page = 1
      this.searchMatchingPlots(typeOfSearch)
    }, 450)
  }
  async searchMatchingPlots(typeOfSearch = "simple") {
    let searchObject = this.composeQuery()
    if (!searchObject) {
      return
    }

    const searchQuery = this.data.searchQuery

    if (!searchQuery && Object.keys(searchObject).length === 0) {
      this.$router.push({}).catch(() => {})
      this.searchResultsPaginated = []
      this.data.resultsFound = 0
      this.data.controlParams.page = 1
      this.totalSearchResults = 0
      this.data.quickSearchDialog = true
      return
    }

    searchObject.page = this.data.controlParams.page
    searchObject.size = this.data.controlParams.size

    if (searchQuery) {
      searchObject.searchQuery = searchQuery
    }

    //safely push new route even if it is the same values and block errors
    this.$router.push({query: searchObject}).catch(() => {})

    delete searchObject.searchQuery

    const searchQueryObject = Object.keys(searchObject)
      .map((key) => key + "=" + searchObject[key])
      .join("&")

    let results = await searchService.search(searchQuery, searchQueryObject, typeOfSearch)
    //check if results have hits
    if (!results || !results.hits || !results.hits.hits) {
      console.log("No results found", results ? results.errorCode : "")
      if (results && results.errorCode == "LIMIT_REACHED_ADVANCE_SEARCH") {
        utils.showSnackbarError(results.error && results.errorMessage ? results.errorMessage : "No results found")
      } else {
        utils.showSnackbarWarning("Unable to obtain results from the server. Please try again shortly.s")
      }
      return
    }
    this.data.quickSearchDialog = false
    results.hits.hits.forEach((i) => {
      this.searchResultsPaginated.push(i._source)
    })
    this.totalSearchResults = results.hits.total.value
    if (this.totalSearchResults > 0) {
      this.MAX_PAGES = Math.ceil(this.totalSearchResults / this.data.controlParams.size)
      if (this.MAX_PAGES > 100) {
        this.MAX_PAGES = 100
      }
    }

    if (this.onSerachResultFlyTo1stResult && this.onClickSearchResultFlyToPlot) {
      this.flyToSearchResultPosition(0)
    }

    this.data.totalsByLocation = results.aggregations?.byLocation?.buckets

    this.$nextTick(() => {
      this.searchResultsPaginated.forEach((i) => {
        this.drawFeatureForSearchNEW(i.PRC_ID)
      })
      this.showLayer()
    })
  }

  async drawFeatureForSearchNEW(PRC_ID) {
    let featureAndObjects = await this.loadPlotBriefForPrcID(PRC_ID)
    this.drawFeatureWithObjectsNEW(featureAndObjects?.feature, featureAndObjects?.objects, "canvas_" + PRC_ID)
  }

  async pageNext() {
    this.searchResultsPaginated = []
    this.searchMatchingPlots()
  }

  flyToSearchResultPosition(position) {
    //compute new x,y for zoom = 15. x, y should be from the geometry of the first result
    if (this.searchResultsPaginated.length === 0) {
      console.log("flyToSearchResultPosition no results found")
      return
    }
    if (this.searchResultsPaginated.length <= position) {
      console.log("flyToSearchResultPosition position exceed results")
      return
    }
    let itemAtPosition: any = this.searchResultsPaginated[position]
    if (itemAtPosition) {
      // console.log("itemAtPosition", itemAtPosition)
      let centroid = itemAtPosition.centroid

      let x = centroid.coordinates[0]
      let y = centroid.coordinates[1]

      let ZOOM = 17

      setTimeout(() => {
        console.log("this.data.map.getPitch()", this.data.map.getPitch())
        this.data.map.flyTo({
          center: [x, y],
          zoom: ZOOM,
          pitch: this.data.map.getPitch(),
          bearing: this.data.map.getBearing(),
          essential: true,
        })
      }, 333)

      this.showLayer()
    }
  }

  showLayer() {
    this.fullResults = {}
    if (!this.loaded) {
      return
    }

    this.data.searching = true
    this.searchingTimeoutId = setTimeout(() => {
      this.data.searching = false
    }, 2500)

    this.data.newCenter = null

    this.setupMapMainPlot()
    this.setupMapPlotsAround()
    this.setupMapCusters()
    this.setupSingleViewPlot(null)
  }

  setupSingleViewPlot(item) {
    if (this.data.map.getSource(this.sourceNameSingleView)) {
      if (item == null) {
        return
      }

      let FEATURES: any = []

      if (item?.centroid) {
        let feature = {
          type: "Feature",
          properties: {
            id: item.PRC_ID,
          },
          geometry: item?.centroid,
        }
        FEATURES.push(feature)
      }

      const DATA = {
        type: "FeatureCollection",
        crs: {type: "name", properties: {name: "urn:ogc:def:crs:OGC:1.3:CRS84"}},
        features: FEATURES,
      }

      // //update geojson source data with new DATA
      this.data.map.getSource(this.sourceNameSingleView).setData(DATA)
      this.data.map.triggerRepaint()
      return
    }

    let FEATURES: any = []
    if (item?.centroid) {
      let feature = {
        type: "Feature",
        properties: {
          id: item.PRC_ID,
        },
        geometry: item?.centroid,
      }
      FEATURES.push(feature)
    }

    const DATA = {
      type: "FeatureCollection",
      features: FEATURES,
    }

    this.data.map.addSource(this.sourceNameSingleView, {
      type: "geojson",
      data: DATA,
    })
    // console.log("DATA", JSON.stringify(DATA, null, 2))

    this.data.map.addLayer({
      id: "searchResultPlotSelected",
      type: "circle",
      source: this.sourceNameSingleView,
      minzoom: 10,
      maxzoom: 24,
      paint: {
        "circle-color": "#2199a5",
        "circle-radius": 10,
        "circle-opacity": 1,
      },
    })
  }

  setupMapCusters() {
    if (this.data.map.getSource(this.sourceNameClusters)) {
      let FEATURES: any = []
      if (this.data && this.data.totalsByLocation) {
        this.data.totalsByLocation.forEach((item) => {
          if (item?.city?.geometry) {
            let feature = {
              type: "Feature",
              properties: {
                id: item.key,
                doc_count: item.doc_count,
              },
              geometry: item.city?.geometry,
            }
            FEATURES.push(feature)
          }
        })
      }

      const DATA = {
        type: "FeatureCollection",
        crs: {type: "name", properties: {name: "urn:ogc:def:crs:OGC:1.3:CRS84"}},
        features: FEATURES,
      }

      // //update geojson source data with new DATA
      this.data.map.getSource(this.sourceNameClusters).setData(DATA)
      this.data.map.triggerRepaint()
      return
    }

    let FEATURES: any = []
    if (this.data && this.data.totalsByLocation) {
      this.data.totalsByLocation.forEach((item) => {
        if (item?.city?.geometry) {
          let feature = {
            type: "Feature",
            properties: {
              id: item.key,
              doc_count: item.doc_count,
            },
            geometry: item.city?.geometry,
          }
          FEATURES.push(feature)
        }
      })
    }

    const DATA = {
      type: "FeatureCollection",
      features: FEATURES,
    }

    this.data.map.addSource(this.sourceNameClusters, {
      type: "geojson",
      data: DATA,
    })

    this.data.map.addLayer({
      id: "clusters",
      type: "circle",
      source: this.sourceNameClusters,
      minzoom: this.startingZoom,
      maxzoom: this.startingZoomPlotsAround,
      paint: {
        "circle-color": "#2199A5", //0E2829//0D5775
        "circle-radius": 20,
        "circle-opacity": 0.7,
      },
    })

    this.data.map.addLayer({
      id: "cluster-count",
      type: "symbol",
      source: this.sourceNameClusters,
      minzoom: this.startingZoom,
      maxzoom: this.startingZoomPlotsAround,
      layout: {
        "text-field": "{doc_count}",
        "text-font": ["Frutiger Neue Regular"],
        "text-size": 13,
      },
      paint: {
        "text-color": "#ffffff",
      },
    })
  }

  setupMapMainPlot() {
    console.log("Setting up the main plot")
    const searchQuery = this.data.searchQuery

    const fillStyle = "layer_fill" // arbitrary value, you can use any string you like
    const outlineStyle = "layer_line" // arbitrary value, you can use any string you like
    const sourceLayer = "hits" // not arbitrary value - must be layer name provided from tile
    const fillColor = "rgb(247, 51, 120)" //rgb(77, 173, 183)
    const fillOpacity = ["case", ["boolean", ["feature-state", "hover"], false], 0.5, 0.2]
    const strokeColor = "rgb(247, 51, 120)"
    const strokeOpacity = 1
    const strokeWidth = 1

    const searchObject = this.composeQuery()
    if (!searchObject) {
      return
    }
    const searchQueryObject = Object.keys(searchObject)
      .map((key) => key + "=" + searchObject[key])
      .join("&")

    if (this.data.map.getSource(this.sourceNamePlots)) {
      console.log("UPDATE:::: Updating tiles for the main plot as it already exists on the map", this.data.map.getSource(this.sourceNamePlots))
      //Update tiles url only and refresh it

      // Set the tile url to a cache-busting url (to circumvent browser caching behaviour):
      this.data.map.getSource(this.sourceNamePlots).tiles = [`${this.apiUrl}/v1/secure/user/maps/tile?x={x}&y={y}&z={z}&searchQuery=${searchQuery}&${searchQueryObject}`]

      // Remove the tiles for a particular source
      console.log("this.data.map.style", this.data.map.style)
      if (this.data.map.style && this.data.map.style.sourceCaches && this.data.map.style.sourceCaches[this.sourceNamePlots]) {
        this.data.map.style.sourceCaches[this.sourceNamePlots].clearTiles()

        // Load the new tiles for the current viewport (map.transform -> viewport)
        this.data.map.style.sourceCaches[this.sourceNamePlots].update(this.data.map.transform)
      }

      // Force a repaint, so that the map will be repainted without you having to touch the map
      this.data.map.triggerRepaint()

      return
    } else {
      console.log("ADD:::: Adding source and tiles for the main plot as it does not exist yet on the map")
    }

    this.data.map.addSource(this.sourceNamePlots, {
      type: "vector",
      tiles: [`${this.apiUrl}/v1/secure/user/maps/tile?x={x}&y={y}&z={z}&searchQuery=${searchQuery}&${searchQueryObject}`],
      minzoom: this.startingZoomPlotsAround,
      maxzoom: 24,
      promoteId: {
        hits: "_id",
      },
    })
    console.log("Source ", this.sourceNamePlots, " added to the map with tiles url: ", `${this.apiUrl}/v1/secure/user/maps/tile?x={x}&y={y}&z={z}&searchQuery=${searchQuery}&${searchQueryObject}`)

    this.data.map.addLayer({
      id: outlineStyle,
      type: "line",
      source: this.sourceNamePlots,
      "source-layer": sourceLayer,
      paint: {
        "line-opacity": strokeOpacity,
        "line-color": strokeColor,
        "line-width": 1,
      },
    })

    this.data.map.addLayer({
      id: fillStyle,
      type: "fill",
      source: this.sourceNamePlots,
      "source-layer": sourceLayer,
      paint: {
        "fill-opacity": fillOpacity,
        "fill-color": fillColor,
      },
    })

    //3d terrain source only mneeded for Height value extraction
    this.data.map.addSource("demSource", {
      type: "raster-dem",
      url: "cog://" + this.mapStyleRoot + "/terrain_COG.tif#dem",
      tileSize: 256,
      maxzoom: 15,
      minzoom: 6,
    })

    this.data.map.on("error", function (e) {
      console.log("Error triggered on MAP")
      if (e.error && e.error.message) {
        console.error("Error loading tile:", e.error.message)
      } else {
        console.error("Error loading tile:", e)
      }
    })
  }

  highlighedSinglePlot(feature) {
    if (this.data.clickedOnLastFeature) {
      this.data.map.setFeatureState({source: this.data.clickedOnLastFeature.source, sourceLayer: this.data.clickedOnLastFeature.layer["source-layer"], id: this.data.clickedOnLastFeature.id}, {clickedOn: false})
    }
    if (feature) {
      this.data.clickedOnLastFeature = feature
      this.data.map.setFeatureState({source: feature.source, sourceLayer: feature.layer["source-layer"], id: feature.id}, {clickedOn: true})
    }
  }

  setupMapObjects() {
    const searchQuery = this.data.searchQuery

    const fillStyle = "layer_fill_objects" // arbitrary value, you can use any string you like
    const outlineStyle = "layer_line_objects" // arbitrary value, you can use any string you like
    const sourceLayer = "hits" // not arbitrary value - must be layer name provided from tile
    const fillColor = "rgb(255,0,0)"
    const fillOpacity = ["case", ["boolean", ["feature-state", "hover"], false], 0.5, 0.2]
    const strokeColor = "rgb(0,0,0)"
    const strokeOpacity = 1
    const strokeWidth = 1

    const searchObject = this.composeQuery()
    if (!searchObject) {
      return
    }
    const searchQueryObject = Object.keys(searchObject)
      .map((key) => key + "=" + searchObject[key])
      .join("&")

    if (this.data.map.getSource(this.sourceNameObjects)) {
      //Update tiles url only and refresh it

      // Set the tile url to a cache-busting url (to circumvent browser caching behaviour):
      this.data.map.getSource(this.sourceNameObjects).tiles = [`${this.apiUrl}/v1/secure/user/maps/objects?x={x}&y={y}&z={z}&searchQuery=${searchQuery}&${searchQueryObject}`]

      // Remove the tiles for a particular source
      if (this.data.map.style && this.data.map.style.sourceCaches && this.data.map.style.sourceCaches[this.sourceNameObjects]) {
        this.data.map.style.sourceCaches[this.sourceNameObjects].clearTiles()

        // Load the new tiles for the current viewport (map.transform -> viewport)
        this.data.map.style.sourceCaches[this.sourceNameObjects].update(this.data.map.transform)
      }

      // Force a repaint, so that the map will be repainted without you having to touch the map
      this.data.map.triggerRepaint()

      return
    }

    this.data.map.addSource(this.sourceNameObjects, {
      type: "vector",
      tiles: [`${this.apiUrl}/v1/secure/user/maps/objects?x={x}&y={y}&z={z}&searchQuery=${searchQuery}&${searchQueryObject}`],
      minzoom: this.startingZoomPlotsAround,
      maxzoom: 24,
      promoteId: {
        hits: "_id",
      },
    })

    this.data.map.addLayer({
      id: outlineStyle,
      type: "line",
      source: this.sourceNameObjects,
      "source-layer": sourceLayer,
      paint: {
        "line-opacity": strokeOpacity,
        "line-color": strokeColor,
        "line-width": 1,
      },
    })
    this.data.map.setFilter(outlineStyle, ["any", ["==", ["geometry-type"], "Polygon"], ["==", ["geometry-type"], "MultiPolygon"], ["==", ["geometry-type"], "LineString"], ["==", ["geometry-type"], "MultiLineString"]])

    this.data.map.addLayer({
      id: fillStyle,
      type: "fill",
      source: this.sourceNameObjects,
      "source-layer": sourceLayer,
      paint: {
        "fill-opacity": fillOpacity,
        "fill-color": fillColor,
      },
    })
    this.data.map.setFilter(fillStyle, ["any", ["==", ["geometry-type"], "Polygon"], ["==", ["geometry-type"], "MultiPolygon"]])
  }

  setupMapPlotsAround() {
    const fillStyle = "layer_fill_around" // arbitrary value, you can use any string you like
    const outlineStyle = "layer_line_around" // arbitrary value, you can use any string you like
    const sourceLayer = "hits" // not arbitrary value - must be layer name provided from tile
    const fillOpacity = ["case", ["boolean", ["feature-state", "hover"], false], 0.2, ["boolean", ["feature-state", "clickedOn"], false], 0.5, 0.0]
    const fillColor = [
      "case",
      ["boolean", ["feature-state", "clickedOn"], false],
      "#2199a5", // Red color when clicked
      "#0000ff", // Default color (blue)
    ]

    const strokeColor = "#777777"
    const strokeOpacity = 1
    const strokeWidth = 1

    if (this.data.map.getSource(this.sourceNamePlotsAround)) {
      //Update tiles url only and refresh it

      // Set the tile url to a cache-busting url (to circumvent browser caching behaviour):
      this.data.map.getSource(this.sourceNamePlotsAround).tiles = [`${this.apiUrl}/v1/secure/user/maps/all-around?x={x}&y={y}&z={z}`]

      // Remove the tiles for a particular source
      if (this.data.map.style && this.data.map.style.sourceCaches && this.data.map.style.sourceCaches[this.sourceNamePlotsAround]) {
        this.data.map.style.sourceCaches[this.sourceNamePlotsAround].clearTiles()

        // Load the new tiles for the current viewport (map.transform -> viewport)
        this.data.map.style.sourceCaches[this.sourceNamePlotsAround].update(this.data.map.transform)
      }

      // Force a repaint, so that the map will be repainted without you having to touch the map
      this.data.map.triggerRepaint()

      return
    }

    this.data.map.addSource(this.sourceNamePlotsAround, {
      type: "vector",
      tiles: [`${this.apiUrl}/v1/secure/user/maps/all-around?x={x}&y={y}&z={z}`],
      minzoom: this.startingZoomPlotsAround,
      maxzoom: 24,
      promoteId: {
        hits: "_id",
      },
    })

    this.data.map.addLayer({
      id: outlineStyle,
      type: "line",
      source: this.sourceNamePlotsAround,
      "source-layer": sourceLayer,
      paint: {
        "line-opacity": strokeOpacity,
        "line-color": strokeColor,
        "line-width": 1,
      },
    })
    this.data.map.setFilter(outlineStyle, ["any", ["==", ["geometry-type"], "Polygon"], ["==", ["geometry-type"], "MultiPolygon"], ["==", ["geometry-type"], "LineString"], ["==", ["geometry-type"], "MultiLineString"]])

    this.data.map.addLayer({
      id: fillStyle,
      type: "fill",
      source: this.sourceNamePlotsAround,
      "source-layer": sourceLayer,
      paint: {
        "fill-opacity": fillOpacity,
        "fill-color": fillColor,
      },
    })
    this.data.map.setFilter(fillStyle, ["any", ["==", ["geometry-type"], "Polygon"], ["==", ["geometry-type"], "MultiPolygon"]])
  }

  hoveredStateId = null
  timeoutId
  lastHit: any = null

  async onMapMouseMove(e) {
    if (!this.loaded || !this.data.map || this.data.searching) return; // Add this line

    this.popup.remove()

    const layersToQuery = ["layer_fill", "layer_fill_around"].filter((layer) => this.data.map.getLayer(layer))
    if (layersToQuery.length > 0) {
      const features = this.data.map.queryRenderedFeatures(e.point, {
        layers: layersToQuery,
      })
      const feature = features ? features[0] : null
      if (!feature) {
        return
      }
      let featureID = feature.id
      if (!featureID) {
        return
      }

      this.data.map.getCanvas().style.cursor = "pointer"

      clearTimeout(this.timeoutId)

      const coordinates = feature.geometry.coordinates.slice()
      const description = feature.properties.description

      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
      }

      if (this.hoveredStateId) {
        this.data.map.setFeatureState({source: this.sourceNamePlotsAround, sourceLayer: "hits", id: this.hoveredStateId}, {hover: false})
      }

      this.hoveredStateId = featureID
      this.data.map.setFeatureState({source: this.sourceNamePlotsAround, sourceLayer: "hits", id: this.hoveredStateId}, {hover: true})
      if (feature) {
        let formattedNumber = feature.properties.PRC_SUR
        if (feature.properties.PRC_SUR) {
          let number = Number(feature.properties.PRC_SUR)
          formattedNumber = number.toLocaleString()
        }

        let radon = ``
        if (feature.properties.GRN_RAD > 10) {
          radon = `<span style='color:red;font-size:20px'>&#9888;</span>`
        }

        let height = await this.extractHeighFromLayer(e)

        let htmll = `
          <div style='width:100%;margin-bottom:10px;display:flex;justify-content:space-between'><h3 style='text-transform:uppercase'>${this.plotPrefix}-${feature.properties.STATE}-${feature.properties.LOCNAME}-${feature.properties.PRC_NO}</h3>${radon}</div>
          <p>- ${formattedNumber} m2<br>- ${feature.properties.ALPHA_PRI}</p><p>ID: ${feature.id}</p>${height ? "<p>Height: " + height + " " + this.METER_UNIT_CODE + "</p>" : ""} `

        this.timeoutId = setTimeout(() => {
          // const popupOffset = e.point.y > 180 ? [0, -15] : [0, 15];

          this.popup.setLngLat(e.lngLat).setHTML(htmll)
          // .setOffset(popupOffset); // Initial zero offset

          // Add the popup to the map
          if (!this.popup._map) {
            this.popup.addTo(this.data.map)
          }
        }, this.DELAY_IN_POPUP_MS)
      }
    } else {
      console.warn("No layers available to query.")
    }
  }

  async extractHeighFromLayer(e) {
    // const {lngLat: {lat: latitude, lng: longitude}} = this.data.map.getCenter();
    const {
      lngLat: {lat: latitude, lng: longitude},
      point: {x, y},
    } = e
    const zoom = this.data.map.getZoom()
    //console.log("zoom", zoom, latitude, longitude);

    let extractedHeight = await locationValues(this.mapStyleRoot + "/terrain_COG.tif", {latitude: latitude, longitude: longitude})
      .then((values) => {
        // console.log("values", values)
        if (!values || !values.length) {
          console.log("No height values returned")
          return 0
        }
        const height = Math.round(values[0])
        if (isNaN(height)) {
          return 0
        } else {
          return height
        }
      })
      .catch((error) => {
        console.error("Error extracting height:", error)
        return 0
      })

    //console.log("extractedHeight", extractedHeight);
    return extractedHeight || 0
  }
  async onMapMouseLeave(e) {
    clearTimeout(this.timeoutId)
    if (this.hoveredStateId) {
      this.data.map.setFeatureState({source: this.sourceNamePlotsAround, sourceLayer: "hits", id: this.hoveredStateId}, {hover: false})
    }
    this.data.map.getCanvas().style.cursor = ""
    this.popup.remove()
    this.hoveredStateId = null
  }

  async onMapPlotClick(e) {
    const layersToQuery = ["layer_fill", "layer_fill_around"].filter((layer) => this.data.map.getLayer(layer))
    if (layersToQuery.length > 0) {
      const features = this.data.map.queryRenderedFeatures(e.point, {
        layers: layersToQuery,
      })
      const feature = features ? features[0] : null
      if (!feature) {
        return
      }
      let featureID = feature.id
      if (!featureID) {
        return
      }
      let featureAndObjects: any = null
      if (this.lastHit && this.lastHit.feature && this.lastHit.feature.PRC_ID == featureID) {
        console.log("Using cached last hit")
        featureAndObjects = this.lastHit
      } else {
        console.log("Loading new hit from server")
        this.highlighedSinglePlot(feature)
        featureAndObjects = await this.loadPlotFullForPrcID(featureID)
        this.lastHit = featureAndObjects
      }
      this.activatePlotViewNEW(featureAndObjects)
      this.drawFeatureWithObjectsNEW(featureAndObjects?.feature, featureAndObjects?.objects, "canvas", true)
    } else {
      console.warn("No layers available to query.")
    }
  }

  additionalData() {
    var myFeatures = this.data.map.querySourceFeatures(this.sourceNamePlots, {
      sourceLayer: "hits",
    })

    if (myFeatures.length > 0) {
      // console.log("myFeatures.length additionalData", myFeatures.length)
    }
    myFeatures.forEach((i) => {
      this.fullResults[i.properties.PRC_ID] = 1
    })
    this.data.resultsFound = Object.keys(this.fullResults).length
  }

  activatePlotViewNEW(featureAndObjects) {
    Vue.set(this.data, "activeResultFeature", featureAndObjects?.feature)
    Vue.set(this.data, "activeResultObjects", featureAndObjects?.objects)
    Vue.set(this.data, "activeResultCanton", featureAndObjects?.canton)
  }

  //this uses tracking on the backend for full view tracking
  async loadPlotFullForPrcID(PRC_ID) {
    let featureAndObjects = await searchService.loadFullDetailsForPrcID(PRC_ID)
    if (featureAndObjects && featureAndObjects.feature) {
      this.drawCentroidToFixedPoint(featureAndObjects)

      return this.processPlotAndObjectData(featureAndObjects)
    } else if (featureAndObjects && featureAndObjects.error) {
      utils.showSnackbarError(featureAndObjects.errorMessage + "\n\n" + "Check your Plan and upgrade to receive more limits")
    } else {
      utils.showSnackbarError("No results found")
    }
  }

  drawCentroidToFixedPoint(featureAndObjects) {
    if (this.drawFixPoint === false) {
      return
    }
    let feature = featureAndObjects?.feature
    if (!feature || !feature.centroid) {
      return
    }
    let fixedX = feature.FIX_COO_X
    let fixedY = feature.FIX_COO_Y
    let centroidX = feature.centroid.coordinates[0]
    let centroidY = feature.centroid.coordinates[1]
    if (typeof fixedX === "number" && typeof fixedY === "number" && typeof centroidX === "number" && typeof centroidY === "number") {
      this.removeFixedPointLink()

      console.log("DRAWING LINE.................", [centroidX, centroidY], [fixedX, fixedY])
      this.data.map.addSource("fixed-point-link", {
        type: "geojson",
        data: {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [
              [centroidX, centroidY],
              [fixedX, fixedY],
            ],
          },
        },
      })
      this.data.map.addLayer({
        id: "fixed-point-link-layer",
        type: "line",
        source: "fixed-point-link",
        paint: {
          "line-color": "#ff0000",
          "line-width": 4,
        },
      })

      this.activatePanel = ["fixpoints"]
    }
  }
  removeFixedPointLink() {
    // Remove previous line if exists
    if (this.data.map.getLayer("fixed-point-link-layer")) {
      this.data.map.removeLayer("fixed-point-link-layer")
    }
    if (this.data.map.getSource("fixed-point-link")) {
      this.data.map.removeSource("fixed-point-link")
    }
  }

  drawFixPoint = false
  onDrawFixPoint(val) {
    this.drawFixPoint = val
    console.log("drawFixPoint", val)
    if (this.drawFixPoint == true) {
      let feature = this.data.activeResultFeature
      this.drawCentroidToFixedPoint({feature: feature})
      // this.activatePanel = ["fixpoints"]
    } else {
      this.removeFixedPointLink()
      // this.activatePanel = []
    }
  }

  async loadPlotBriefForPrcID(PRC_ID) {
    let featureAndObjects = await searchService.loadObjectsForPrcID(PRC_ID)
    if (featureAndObjects) {
      return this.processPlotAndObjectData(featureAndObjects)
    }
  }
  async processPlotAndObjectData(featureAndObjects) {
    if (featureAndObjects.feature) {
      let langcode = localStorage.getItem("user-language")
      let kangAsKey = langcode ? String(langcode) : ""
      if (kangAsKey) {
        let langVals = featureAndObjects.feature?.lang?.[kangAsKey]
        if (langVals) {
          featureAndObjects.feature = {...featureAndObjects.feature, ...langVals}
        }
      }

      if (featureAndObjects.objects) {
        let langcode = localStorage.getItem("user-language")
        let kangAsKey = langcode ? String(langcode) : ""
        if (kangAsKey) {
          featureAndObjects.objects.forEach((i, index) => {
            let langVals = i?.lang?.[kangAsKey]
            if (langVals) {
              langVals.objectTypeKey = i.OBJ_TYP
              featureAndObjects.objects[index] = {...i, ...langVals}
            }
          })
        }
      }

      return featureAndObjects
    }
  }

  drawFeatureWithObjectsNEW(feature, objects: any = [], canvasElementId, flyTo = false) {
    if (!feature) {
      return
    }
    this.data.dialog = true
    this.$nextTick(() => {
      let canvas: any = document.getElementById(canvasElementId)
      if (!canvas) {
        console.log("Canvas not found", canvasElementId)
        return
      }
      let ctx = canvas.getContext("2d")
      //clean canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      //loop over multipoligy on the feature and draw them
      let appP = []
      feature.geometry.coordinates.forEach((coord) => {
        let points = coord[0].map((i) => {
          return [i[0], i[1]]
        })
        appP = appP.concat(points)
      })

      const bounds = searchService.calculateBounds(appP)

      //loop over objects features and draw parcel
      objects.forEach((obj: any) => {
        obj.geometry.coordinates.forEach((coord) => {
          let points = coord[0].map((i) => {
            return [i[0], i[1]]
          })
          let colorForObjectType = this.objectColors[obj.objectTypeKey || obj.OBJ_TYP]
          this.drawParcelNEW(canvas, ctx, points, bounds, colorForObjectType || "silver")
        })
        if (obj.centroid && obj.OBJ_PRO_LABEL && String(obj.OBJ_PRO_LABEL).toUpperCase() == "Y") {
          this.drawCircleOnCoords(canvas, ctx, obj.centroid.coordinates[0], obj.centroid.coordinates[1], bounds, "orange")
        }
      })

      feature.geometry.coordinates.forEach((coord) => {
        let points = coord[0].map((i) => {
          return [i[0], i[1]]
        })
        this.drawParcelNEW(canvas, ctx, points, bounds, "transparent")
      })

      if (flyTo) {
        setTimeout(() => {
          this.data.map.flyTo({
            center: feature.centroid.coordinates,
            zoom: 17,
            pitch: this.data.map.getPitch(),
            bearing: this.data.map.getBearing(),
            essential: true,
          })
        }, 333)
      }
    })
  }
  drawCircleOnCoords(canvas, ctx, x, y, bounds, color) {
    var {minX, minY, maxX, maxY} = bounds

    // Calculate map dimensions and center
    const mapWidth = maxX - minX
    const mapHeight = maxY - minY
    const mapCenterX = (maxX + minX) / 2
    const mapCenterY = (maxY + minY) / 2

    // Calculate the scale to fit the canvas
    const scale = Math.min(canvas.width / mapWidth, canvas.height / mapHeight)

    // Transform the coordinates to canvas space
    const X = (x - mapCenterX) * scale + canvas.width / 2
    const Y = canvas.height - ((y - mapCenterY) * scale + canvas.height / 2)

    // Draw the circle
    ctx.beginPath()
    ctx.arc(X, Y, canvas.width * 0.02, 0, 2 * Math.PI)
    ctx.fillStyle = color
    ctx.strokeStyle = "red"
    ctx.lineWidth = 1
    ctx.stroke()
    ctx.fill()
  }

  drawParcelNEW(canvas, ctx, myPoints, bounds, fillStyle = "white") {
    var {minX, minY, maxX, maxY} = bounds

    // 1. Calculate Center
    const mapCenterLon = (maxX + minX) / 2
    const mapCenterLat = (maxY + minY) / 2

    // 2. Calculate the Aspect Ratio Correction
    // As you move north/south, the distance between longitude lines shrinks.
    // We multiply the Longitude (X) differences by the Cosine of the Latitude.
    // convert Lat to radians: (Lat * Math.PI / 180)
    const latRadians = mapCenterLat * (Math.PI / 180)
    const correctionFactor = Math.cos(latRadians)

    // 3. Calculate Width/Height in "adjusted" units (approximating meters)
    const mapWidth = (maxX - minX) * correctionFactor
    const mapHeight = maxY - minY

    // Add a little padding (e.g., 90% of canvas) so it doesn't touch edges
    const padding = 0.9

    // 4. Calculate Scale to fit canvas
    const scale = Math.min((canvas.width * padding) / mapWidth, (canvas.height * padding) / mapHeight)

    ctx.beginPath()

    myPoints.forEach((p) => {
      // p[0] is Longitude, p[1] is Latitude

      // Apply correction to the X distance
      const distLon = (p[0] - mapCenterLon) * correctionFactor
      const distLat = p[1] - mapCenterLat

      const X = distLon * scale + canvas.width / 2
      const Y = distLat * scale + canvas.height / 2

      // Render (Flip Y because Canvas 0,0 is top-left, but Map 0,0 is bottom-left)
      ctx.lineTo(X, canvas.height - Y)
    })

    ctx.fillStyle = fillStyle
    ctx.fill()
    ctx.lineWidth = 1
    ctx.strokeStyle = "#000000"
    ctx.stroke()
  }

  // drawParcelNEW_3dSphericalRepresentation(canvas, ctx, myPoints, bounds, fillStyle = "white") {
  //   var {minX, minY, maxX, maxY} = bounds

  //   // now get the map width and heigth in its local coords
  //   const mapWidth = maxX - minX
  //   const mapHeight = maxY - minY
  //   const mapCenterX = (maxX + minX) / 2
  //   const mapCenterY = (maxY + minY) / 2

  //   // to find the scale that will fit the canvas get the min scale to fit height or width
  //   const scale = Math.min(canvas.width / mapWidth, canvas.height / mapHeight)

  //   // Now you can draw the map centered on the cavas
  //   ctx.beginPath()
  //   myPoints.forEach((p) => {
  //     const X = (p[0] - mapCenterX) * scale + canvas.width / 2 //(p[0] - mapCenterX) * scale + canvas.width / 2
  //     const Y = (p[1] - mapCenterY) * scale + canvas.height / 2 //(p[1] - mapCenterY) * scale + canvas.height / 2
  //     ctx.lineTo(X, canvas.height - Y)
  //   })
  //   ctx.fillStyle = fillStyle
  //   ctx.fill()
  //   ctx.lineWidth = 1
  //   ctx.strokeStyle = "#000000"

  //   ctx.stroke()
  // }

  // calculateBounds(points) {
  //   let minX, maxX, minY, maxY

  //   points.forEach((p, i) => {
  //     if (i === 0) {
  //       minX = maxX = p[0]
  //       minY = maxY = p[1]
  //     } else {
  //       minX = Math.min(p[0], minX)
  //       minY = Math.min(p[1], minY)
  //       maxX = Math.max(p[0], maxX)
  //       maxY = Math.max(p[1], maxY)
  //     }
  //   })

  //   return {minX, maxX, minY, maxY}
  // }

  sourceCallback() {
    // assuming 'map' is defined globally, or you can use 'this'
    if (this.data.newCenter != null) {
      return
    }
    if (this.data.map.getSource(this.sourceNamePlots) && this.data.map.isSourceLoaded(this.sourceNamePlots)) {
      //get multipoligon geo coordinates for the source

      var myFeatures = this.data.map.querySourceFeatures(this.sourceNamePlots, {
        sourceLayer: "hits", //"layer_fill"
        // filter: ["==", "postcode", "3000"],
      })

      if (myFeatures[0]?.geometry?.coordinates[0][0]) {
        this.data.newCenter = myFeatures[0]?.geometry?.coordinates[0][0]
        let TOZOOM = 13

        if (this.totalSearchResults == 1) {
          TOZOOM = 15
        }

        if (this.hitSearchButton == true) {
          this.hitSearchButton = false
        }
      }
    }
  }

  extractQueryParams() {
    if (!this.data.searchObject) {
      this.data.searchObject = {}
    }

    const query = this.$route.query
    let searchObject: any = {} //Object.assign({}, this.data.searchObject)

    if (query.CANTON) {
      searchObject.CANTON = {_id: query.CANTON, code: query.CANTON}
    }

    if (query.LOCNAME) {
      searchObject.LOCNAME = String(query.LOCNAME)
        .split("||")
        .map((code) => ({code}))
    }

    if (query.STREET) {
      searchObject.STREET = String(query.STREET)
        .split("||")
        .map((code) => ({_id: code, code: code, locname: "", canton: ""}))
    }

    if (query.PRC_SUR) {
      const [from, to] = query.PRC_SUR ? String(query.PRC_SUR).split("-") : [null, null]
      searchObject.PRC_SUR_from = from !== "0" ? from : null
      searchObject.PRC_SUR_to = to !== "99999999999" ? to : null
    }

    if (query.PUTRA) {
      const [from, to] = query.PUTRA ? String(query.PUTRA).split("-") : [null, null]
      searchObject.PUTRA_from = from !== "0" ? from : null
      searchObject.PUTRA_to = to !== "99999999999" ? to : null
    }

    if (query.GRN_TRM) {
      searchObject.GRN_TRM = query.GRN_TRM == "true" ? true : false
    }

    if (query.ALPHA_PRI) {
      searchObject.ALPHA_PRI = String(query.ALPHA_PRI)
        .split("||")
        .map((code) => ({code: code, label: code}))
    }
    if (query.ALPHA_PRIS) {
      searchObject.ALPHA_PRIS = String(query.ALPHA_PRIS)
        .split("||")
        .map((code) => ({code: code, label: code}))
    }

    if (query.ALPHA_SEC) {
      searchObject.ALPHA_SEC = String(query.ALPHA_SEC)
        .split("||")
        .map((code) => ({code: code, label: code}))
    }
    if (query.ALPHA_SECS) {
      searchObject.ALPHA_SECS = String(query.ALPHA_SECS)
        .split("||")
        .map((code) => ({code: code, label: code}))
    }
    if (query.GRN_RAD) {
      searchObject.GRN_RAD = query.GRN_RAD === "0-9"
    }
    if (query.GRN_RAD_LABEL) {
      searchObject.GRN_RAD = query.GRN_RAD_LABEL
    }
    if (query.PRO_BUN) {
      searchObject.PRO_BUN = query.PRO_BUN == "true" ? true : false
    }
    if (query.PRC_IND) {
      searchObject.PRC_IND = query.PRC_IND == "Standard" ? "Standard" : ""
    }
    if (query.PRC_NO) {
      searchObject.PRC_NO = query.PRC_NO
    }
    if (query.PRC_ID) {
      searchObject.PRC_ID = query.PRC_ID
    }
    if (query.OBJECT_OPTIONS) {
      searchObject.OBJECT_OPTIONS = query.OBJECT_OPTIONS
    }
    if (query.PRC_TYP) {
      searchObject.PRC_TYP = query.PRC_TYP
    }

    if (query.page) {
      this.data.controlParams.page = parseInt(String(query.page) || "1")
    }
    if (query.size) {
      this.data.controlParams.size = parseInt(String(query.size) || "12")
    }

    if (query.searchQuery) {
      this.data.searchQuery = String(query.searchQuery)
    }

    Vue.set(this.data, "searchObject", searchObject)
  }

  composeQuery() {
    const MAX_SUR_TO = 15000
    let searchObject = Object.assign({}, this.data.searchObject)
    if (searchObject.PRC_SUR_from || searchObject.PRC_SUR_to) {
      searchObject.PRC_SUR = `${searchObject.PRC_SUR_from || 0}-${searchObject.PRC_SUR_to || MAX_SUR_TO}`
    }
    if (searchObject.PUTRA_from || searchObject.PUTRA_to) {
      searchObject.PUTRA = `${searchObject.PUTRA_from || 0}-${searchObject.PUTRA_to || 99999999999}`
    }
    if (searchObject.CANTON && searchObject.CANTON.code) {
      searchObject.CANTON = searchObject.CANTON.code
    }
    if (searchObject.LOCNAME) {
      searchObject.LOCNAME = searchObject.LOCNAME.map((i) => {
        return i.code
      }).join("||")
    }
    if (searchObject.STREET) {
      searchObject.STREET = searchObject.STREET.map((i) => {
        return i.code
      }).join("||")
    }
    // if (searchObject.GRN_TRM) {
    //   searchObject.GRN_TRM = searchObject.GRN_TRM.map((i) => {
    //     return i.code
    //   }).join("||")
    // }
    if (searchObject.ALPHA_PRI) {
      searchObject.ALPHA_PRI = searchObject.ALPHA_PRI.map((i) => {
        return i.code
      }).join("||")
    }
    if (searchObject.ALPHA_PRIS) {
      searchObject.ALPHA_PRIS = searchObject.ALPHA_PRIS.map((i) => {
        return i.code
      }).join("||")
    }
    if (searchObject.ALPHA_SEC) {
      searchObject.ALPHA_SEC = searchObject.ALPHA_SEC.map((i) => {
        return i.code
      }).join("||")
    }
    if (searchObject.ALPHA_SECS) {
      searchObject.ALPHA_SECS = searchObject.ALPHA_SECS.map((i) => {
        return i.code
      }).join("||")
    }

    if (searchObject.GRN_RAD) {
      searchObject.GRN_RAD = "0-9"
    } else {
      delete searchObject.GRN_RAD
    }
    if (searchObject.GRN_RAD_LABEL) {
      searchObject.GRN_RAD = searchObject.GRN_RAD_LABEL == "N" ? "0-9" : "10-999"
    }

    // New formatters for AdvanceSearch fields
    if (searchObject.PRC_ASP && Array.isArray(searchObject.PRC_ASP)) {
      searchObject.PRC_ASP = searchObject.PRC_ASP.join("||")
    }

    if (searchObject.BRAVO_PRI && Array.isArray(searchObject.BRAVO_PRI)) {
      searchObject.BRAVO_PRI = searchObject.BRAVO_PRI.map((i) => i.code).join("||")
    }
    if (searchObject.BRAVO_SEC && Array.isArray(searchObject.BRAVO_SEC)) {
      searchObject.BRAVO_SEC = searchObject.BRAVO_SEC.map((i) => i.code).join("||")
    }

    // Ensure all numeric fields are captured if they have values
    const numericFields = ["PRC_SLO", "YROFBUILD", "OBJ_VOL", "HEIGHT", "OBJ_FLO", "OBJ_UNI", "ENV_WAT", "ENV_FOR", "KA", "GA", "AUTOBAHN_DIST_KM", "HALTESTELLE_DIST_KM", "MARKET_DIST_KM", "SCHULE_DIST_KM", "HOSPITAL_DIST_KM"]
    numericFields.forEach((field) => {
      if (searchObject[field] === 0 || (searchObject[field] && searchObject[field] !== "")) {
        // keep it
      } else {
        delete searchObject[field]
      }
    })

    Object.keys(searchObject).forEach((key) => {
      if (searchObject[key] == null || searchObject[key] == "") {
        delete searchObject[key]
      }
    })

    if (Object.keys(searchObject).length > 0) {
      //this.data.searchQuery = "" //force emptu search if advance search is used
    } else {
      // this.data.searchQuery = searchObject.searchQuery
    }

    let numFromSur = Number(`${searchObject.PRC_SUR_from || 0}`)
    let numToSur = Number(`${searchObject.PRC_SUR_to || MAX_SUR_TO}`)
    if (numFromSur > MAX_SUR_TO || numToSur > MAX_SUR_TO) {
      this.data.limitReachedDialog = true
      return null
    }

    return searchObject
  }
}
</script>

<style scoped>
@import "~maplibre-gl/dist/maplibre-gl.css";

.search-panel {
  height: calc(100vh - 69px) !important;
  border-radius: 0px;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(0, 0, 0, 0.1) white;
}

.map {
  width: 100% !important;
  height: 100%;
}

.map-wrap {
  height: calc(100vh - 65px);
  width: calc(100% - 257px) !important;
  float: right;
}

.map-wrap.with-plot-view {
  width: calc(100% - 738px) !important;
}

.v-navigation-drawer__content {
  overflow-x: none !important;
}

canvas {
  display: block;
  margin: auto;
  border: 2px solid black;
}

.custom-map-popup {
  will-change: transform;
  pointer-events: none;
  /* Makes popup not interfere with mouse events */
}

.custom-map-popup .maplibregl-popup-content {
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
